export class Kv {
  constructor() {
    window.addEventListener('load', this.viewSlide('.slide .item'));
  }

  viewSlide(className, slideNo = -1) {
    let imgArray = document.querySelectorAll(className);
    slideNo++;
    if (slideNo >= imgArray.length) {
      slideNo = 0; //次のスライドがなければ最初のスライドへ戻る
    }
    imgArray[slideNo].classList.add('is-active', 'is-show')
    setTimeout(() => {
      this.viewSlide(className, slideNo);
    },7000);

    //前のスライド消す
    //ループ対策で.is-showと.is-activeは時差で消す
    if(slideNo === 0) {
      //１枚目がカレントの場合は一番最後を消す
      imgArray[imgArray.length - 1].classList.remove('is-show');
      setTimeout(() => {
        imgArray[imgArray.length - 1].classList.remove('is-active');
      }, 2000);
    } else {
      //１つ前を消す
      imgArray[slideNo - 1].classList.remove('is-show');
      setTimeout(() => {
        imgArray[slideNo - 1].classList.remove('is-active');
      }, 2000);
    }
  }
}
